import { Table, TableBody } from '@material-ui/core';
import React from 'react';
import ModalHeadingRow from './ModalHeadingRow';
import ModalTableCells from './ModalTableCells';

const ModalTable = ({ styles, order, orderBy, state, setState }) => {
  return (
    <Table>
      <ModalHeadingRow
        styles={styles}
        orderBy={orderBy}
        order={order}
        state={state}
        setState={(data) => setState(data)}
      />
      <TableBody>
        {state.uoaModalData && state.uoaModalData.length
          ? state.uoaModalData
              .sort((a, b) => {
                if (
                  !orderBy ||
                  (!(
                    typeof a[orderBy] === 'number' ||
                    typeof a[orderBy] === 'string'
                  ) &&
                    // eslint-disable-next-line no-self-compare
                    typeof a[orderBy] === typeof a[orderBy])
                )
                  return 0;

                if (typeof a[orderBy] === 'number')
                  return order === 'desc'
                    ? a[orderBy] - b[orderBy]
                    : b[orderBy] - a[orderBy];
                else {
                  return order === 'desc'
                    ? a[orderBy].localeCompare(b[orderBy])
                    : b[orderBy].localeCompare(a[orderBy]);
                }
              })
              .map((row, index) => {
                return (
                  <ModalTableCells row={row} mykey={index} styles={styles} />
                );
              })
          : 'No Data to Show '}
      </TableBody>
    </Table>
  );
};
export default ModalTable;



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/components/ModalTable.jsx